import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, interval, onErrorResumeNext } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PollService {

  constructor(private http: HttpClient) { }

  public pollServer(intervalTime: number, url: string): Observable<any> {
    return interval(intervalTime).pipe(
      switchMap(() => this.http.get<any>(url, { observe: 'response' }).pipe(
        catchError(error => this.onError(error))
      ))
    );
  }

  private onError(error: any): Observable<any> {
    return new Observable(undefined);
  }

}
